export default __webpack_public_path__ + "static/media/create_account_banner.a31c23f7.jpg";